"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTierForGrade = exports.FIRST_SENIOR_GRADE = void 0;
exports.FIRST_SENIOR_GRADE = 10;
function getTierForGrade(grade, gradeNormalizationShift) {
    const normalizedGrade = grade - (gradeNormalizationShift || 0);
    return normalizedGrade < exports.FIRST_SENIOR_GRADE ? 'JUNIOR' : 'SENIOR';
}
exports.getTierForGrade = getTierForGrade;
